import React, {useEffect} from 'react';
import {useGetCompEventsQuery} from "../../slices/apiSlice";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {getEventDatesString} from "../../pages/Calendar";
import {styled} from "@mui/material/styles";
import {grey} from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import {Edit} from "@mui/icons-material";
import {eventStatus, eventStatusLabel} from "../../util/standards-util";



export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '.85em',
    },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: grey[100],
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const EventTable = ({ series, onEventEdit, onEventSelected, isManager=false }) => {
    const {data: comps, isSuccess} =
        useGetCompEventsQuery({compType:3})

    const [defaultSeries, setDefaultSeries] = React.useState()

    const handleEditClicked = (e, c) => {
        e.stopPropagation()
        const id = e.target.value ? e.target.value : e.target.parentNode.value ? e.target.parentNode.value : e.target.parentNode.parentNode.value
        if (onEventEdit) onEventEdit(comps.find(c => c.id == id)) //needs == instead of === as we convert string to number in the comparison
    }

    const handleSelectClicked = (e,id)=> {
        if (onEventSelected) onEventSelected(comps.find(c => c.id === id))
    }

    useEffect(()=>{
        if (isSuccess){
            const s = Array.from((new Set(comps.map(c => c.series)))).sort((a,b) => {return  b - a})
            setDefaultSeries(s[0])
        }
    },[isSuccess])

    return (
        <>
            {isSuccess && defaultSeries &&
                <TableContainer component={'div'} sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>#</StyledTableCell>
                                <StyledTableCell>Event</StyledTableCell>
                                <StyledTableCell>Venue</StyledTableCell>
                                <StyledTableCell>Dates</StyledTableCell>
                                {isManager && <StyledTableCell>Status</StyledTableCell>}
                                {isManager && <StyledTableCell>&nbsp;</StyledTableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {comps.map((evt) => (
                                evt.series === (series ? series : defaultSeries) &&
                                (isManager || evt.status <=eventStatus.STATUS_PLANNED) &&
                                <StyledTableRow
                                    key={evt.id}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                        "&:hover": {backgroundColor: "#D3EDF4 !important"},
                                    }}
                                    onClick={(e)=>{handleSelectClicked(e,evt.id)}}
                                >
                                    <StyledTableCell component="th" scope="row">
                                        {evt.edition}
                                    </StyledTableCell>
                                    <StyledTableCell>{evt.fullEditionTitle}</StyledTableCell>
                                    <StyledTableCell>{evt.venue}</StyledTableCell>
                                    <StyledTableCell>{getEventDatesString(evt)}</StyledTableCell>
                                    {isManager && <StyledTableCell>{eventStatusLabel[evt.status]}</StyledTableCell>}
                                    {isManager && <StyledTableCell sx={{textAlign:'right'}}>{ evt.status > 20 ? <IconButton value={evt.id} sx={{my:'-8px'}} onClick={handleEditClicked}><Edit fontSize={'small'}/></IconButton> : ' '}</StyledTableCell>}
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </>
    );
};

export default EventTable;